export default "__VITE_ASSET__IEFeaTjJ__"